// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Tooltip from 'vue-directive-tooltip'
import Responsive from 'vue-responsive'
import VModal from 'vue-js-modal'
import VueTimeago from 'vue-timeago'
import VueI18n from 'vue-i18n'
import dateTimeFormats from '../../lang/DateTimeFormat'
import VueResource from 'vue-resource'
require('@/assets/css/neon_titan_stylesheet.css')
require('@/assets/css/neon_titan_stylesheet.scss')

Vue.use(BootstrapVue)
Vue.use(Tooltip)
Vue.use(Responsive)
Vue.use(VModal)
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: undefined, // Default locale
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
    'ja': require('date-fns/locale/ja')
  }
})
Vue.use(VueI18n)
Vue.use(VueResource)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'zh-CN',
  messages: {
    'en-US': require('@/lang/en-US'),
    'zh-CN': require('@/lang/zh-CN')
  },
  dateTimeFormats,
  fallbackLocale: 'en-US'
})

function addI18nModule (module) {
  i18n.mergeLocaleMessage('en-US', require('@/lang/' + module + '/en-US'))
  i18n.mergeLocaleMessage('zh-CN', require('@/lang/' + module + '/zh-CN'))
  return i18n
}

export {addI18nModule}



// WEBPACK FOOTER //
// ./src/modules/common/main.js